export const DROPDOWN_NO_RESULTS_MESSAGE = "dropdown.no.results";
export const DEFAULT_DD_WIDTH = 263;
